import type { SVGProps } from "react";
const SvgBottomWhiskerSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <g clipPath="url(#Bottom_Whisker_SVG_svg__a)">
      <path fill="#CFD7E4" stroke="#2b385f" d="M4.5-6.5h24v16h-24z" />
      <path stroke="#2b385f" d="M16.5 23V10M23 23.5H10" />
      <path fill="#D2D2D2" fillOpacity={0.84} d="M4-26h25v36H4z" />
    </g>
    <defs>
      <clipPath id="Bottom_Whisker_SVG_svg__a">
        <path fill="#fff" d="M0 0h33v33H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBottomWhiskerSvg;
